/**Retorna a primeira imagem que estiver ativa. */

export default {
    methods: {
        getFirstActveImage(images) {
            if (images) {
                let imagem = images.find(obj => {
                    return obj.ativo === 1
                })
                return imagem != undefined ? imagem.imagem : require('../../img/default.png')
           }
           return require('../../img/default.png')
        }
    }
}